import React, { createRef, useEffect, useState } from "react";
import { HiDownload } from "react-icons/hi";
import { BASE_URL, IMAGE_BASE_URL } from "../data/baseURL";

const PoliciesReportCard = ({ data, downloadURL, index }) => {
  const imgRef = createRef();
  const [imageHeight, setImageHeight] = useState();

  useEffect(() => {
    setTimeout(() => {
      setImageHeight(imgRef?.current.clientHeight);
    }, 2000);
  }, [imgRef]);

  return (
    <div className={`row ${index >= 0 ? "pb-5" : ""}`}>
      <div className="col-md-4 pb-5 pb-md-0">
        <div className="text-center">
          <img
            src={`${IMAGE_BASE_URL}/${data?.image}`}
            ref={imgRef}
            className="img-fluid"
            alt=""
          />
        </div>
      </div>
      {/* <div className="col-md-8 border overflow-auto policies-report-card-height"> */}
      <div
        className="col-md-8 border overflow-auto"
        style={{ height: `${imageHeight || 270}px` }}
      >
        <div className="p-4">
          <h6 className="fs-20 lh-30 gilroy-bold">{data?.heading}</h6>
          <p className="fs-16 lh-30 text-orange-ryb gilroy-bold">
            {data?.title}
          </p>
          <p className="fs-16 lh-30 text-align-justify">{data?.description}</p>
          <div className="d-flex justify-content-end">
            <p>
              <a
                href={`${BASE_URL}/${downloadURL}/${data?.id}`}
                download
                className="text-decoration-none fs-14 gilroy-bold text-orange-ryb mt-2 d-block"
              >
                <HiDownload className="text-success" /> Download
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliciesReportCard;
